import { useNavigate } from 'react-router-dom'

import { OfflineHeader } from './../Header/OfflineHeader'
import { useEffect } from 'react'


const NotFound = () => {
    const navigate = useNavigate()


    useEffect(() => {
        document.body.classList.add("BodyComplete")
    }, [])


    return (
        <>
            <OfflineHeader />

            <main className='Container-FullHeight NotFound'>
                <h1 className='NotFound__Title'>404</h1>
                <p className='NotFound__Subtitle'>Lo sentimos. No hemos encontrado la página que buscas.</p>
                <button type='button' className='Btn__Ztudia--Primary NotFound__Button' onClick={() => navigate('/')}>Ir al inicio</button>
            </main>
        </>
    )
}

export { NotFound };